export const DEFAULT_PARAGRAPH_ITEM_SUBTITLE = "Who we are";
export const DEFAULT_PARAGRAPH_ITEM_DESCRIPTION =
  "FOODPhilippines is a branding initiative of the Center for International Trade Expositions & Missions (CITEM) that enforces the image of the Philippines as a top source of quality food products derived from fresh, healthy, and natural ingredients.";
export const DEFAULT_PARAGRAPH_ITEM_CTATEXT = "Register";
